/**
 * Extract YouTube/Vimeo embed URL from various URL formats.
 * @param {string} url - Watch URL (youtube.com/watch?v=..., youtu.be/..., vimeo.com/...)
 * @returns {string|null} - Embed URL or null if invalid
 */
export function getEmbedUrl(url) {
  if (!url || typeof url !== 'string') return null;
  const trimmed = url.trim();

  // YouTube: youtube.com/watch?v=ID, youtu.be/ID, youtube.com/embed/ID
  const ytWatch = trimmed.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([a-zA-Z0-9_-]{11})/);
  if (ytWatch) {
    return `https://www.youtube.com/embed/${ytWatch[1]}`;
  }
  const ytEmbed = trimmed.match(/youtube\.com\/embed\/([a-zA-Z0-9_-]{11})/);
  if (ytEmbed) {
    return trimmed;
  }

  // Vimeo: vimeo.com/123456789
  const vimeo = trimmed.match(/vimeo\.com\/(?:video\/)?(\d+)/);
  if (vimeo) {
    return `https://player.vimeo.com/video/${vimeo[1]}`;
  }

  return null;
}
